import * as turf from "@turf/turf";

const createGeoJSONCircle = function (center, levelAsNumber, properties, points) {
  if (!points) points = 64;

  const coords = {
    latitude: center[1],
    longitude: center[0],
  };

  const km = levelAsNumber * 0.5; // levelAsNumber 1,2,3,4 km => 0.5,1.0,1.5,2.0 km

  const ret = [];
  const distanceX = km / (111.32 * Math.cos((coords.latitude * Math.PI) / 180));
  const distanceY = km / 110.574;

  let theta, x, y;
  for (var i = 0; i < points; i++) {
    theta = (i / points) * (2 * Math.PI);
    x = distanceX * Math.cos(theta);
    y = distanceY * Math.sin(theta);

    ret.push([coords.longitude + x, coords.latitude + y]);
  }
  ret.push(ret[0]);
  const retval = turf.polygon([ret], { explosionColorLevel: levelAsNumber, ...properties });
  return retval;
};

export async function createExplosionGeojsons() {
  const cysRiskExplosionItaDataset =
    "https://cystellar-geojson.s3.amazonaws.com/cys_risk_explosion_ita_ispra_c.geojson";
  const response = await fetch(cysRiskExplosionItaDataset);
  if (!response.ok) {
    throw new Error(`Failed to fetch explosion data: ${response.statusText}`);
  }
  const data = await response.json();

  const points = [];
  const polygons = [];

  data.features.forEach((feature) => {
    const {
      geometry: { coordinates },
      properties,
    } = feature;
    const levelAsNumber = isNaN(properties.level) ? 1 : parseInt(properties.level);

    polygons.push(createGeoJSONCircle(coordinates, levelAsNumber, properties));

    points.push(
      turf.point(coordinates, {
        ...properties,
      }),
    );
  });

  const explosionRisks = {
    type: "FeatureCollection",
    features: polygons,
  };

  const explosionRiskCenters = {
    type: "FeatureCollection",
    features: points,
  };
  return { explosionRiskCenters, explosionRisks };
}

export const createExplosionRiskCircles = async () => {
  const { explosionRisks } = await createExplosionGeojsons();
  return explosionRisks;
};

export const createExplosionRiskCenters = async () => {
  const { explosionRiskCenters } = await createExplosionGeojsons();
  return explosionRiskCenters;
};

export const explosionLayer = {
  //maxzoom: MAX_ZOOM_LEVEL,
  type: "fill",
  source: "explosion",
  paint: {
    "fill-color": [
      "interpolate",
      ["linear"],
      ["get", "explosionColorLevel"],
      1,
      "#fff5f0",
      2,
      "#fca486",
      3,
      "#ea372a",
      4,
      "#67000d",
    ],
    "fill-opacity": 0.55,
  },
};

export const explosionCentersLayer = {
  minzoom: 9,
  type: "circle",
  paint: {
    "circle-radius": 5,
    "circle-color": "rgb(178,24,43)",
  },
};

export const getChanceOfHappeningInPercentage = (noOfYears) => {
  return noOfYears !== 0 && (100 / noOfYears).toFixed(1);
};
